module.exports = __webpack_public_path__ + "img/mobicash.172c5aa2.png";